const ScrollbarGridWidthFix = require('./modules/scrollbar-grid-width-fix.js');
new ScrollbarGridWidthFix();